<app-base-auth>
  <div style="text-align: left; padding: 20px 2px; font-weight: 600">
    {{ "Sign in to your Workspace" | locale | translate }}
  </div>
  <form (ngSubmit)="Login()" class="login-form">
    <nz-form-item>
      <p class="input-title">
        {{ "Email" | locale | translate }}
      </p>
      <input
        type="text"
        class="border-radius"
        nz-input
        #userNameControl
        name="username"
        [placeholder]="'Username' | locale"
        [(ngModel)]="Username"
      />
    </nz-form-item>
    <nz-form-item>
      <p class="input-title">
        {{ "Password" | locale | translate }}
      </p>
      <nz-input-group [nzSuffix]="showPasswordTemplate" class="border-radius">
        <input
          [type]="passwordVisible ? 'text' : 'password'"
          type="password"
          nz-input
          name="password"
          class="border-radius"
          #PasswordControl
          [placeholder]="'Password' | locale | translate" 
          [(ngModel)]="Password"
        />
      </nz-input-group>
      <ng-template #showPasswordTemplate>
        <span
          nz-icon
          [nzType]="passwordVisible ? 'eye-invisible' : 'eye'"
          (click)="passwordVisible = !passwordVisible"
        ></span>
      </ng-template>
      <a
        style="text-align: right; width: 100%"
        [routerLink]="['/auth/reset-password']"
        >Forgot my password</a
      >
    </nz-form-item>
    <button
      nz-button
      nzSize="large"
      class="login-form-button border-radius"
      nzType="primary"
      type="submit"
    >
      {{ "Login" | locale | translate }}
    </button>

   
  </form>
</app-base-auth>
